module.exports = __webpack_public_path__ + "img/logo-infanciasegura-250x110.422d6598.png";